// ©2024 Austin App House. All rights reserved.
import { MDBInput } from 'mdbreact';
import React from 'react';
import FieldLabel from '../../../../FieldLabel';

const EINDisplayControlField = field => (
    <div className="field_row">
        <div className="modal_subtitle">
            {field.label}
            {field.required && <span className="required">*</span>}
        </div>

        <div className="radio_block vertical">
            <label className="wo-check-btn check_btn">
                <input
                    id="YES"
                    type="radio"
                    name="YesNo"
                    checked={field.input.checked}
                    onChange={() => field.input.onChange(true)}
                />
                Yes
            </label>

            <label className="wo-check-btn check_btn">
                <input
                    id="NO"
                    type="radio"
                    name="YesNo"
                    checked={!field.input.checked}
                    onChange={() => field.input.onChange(false)}
                />
                No
            </label>
        </div>
    </div>
);

export default EINDisplayControlField;
